import DashboardLayout from "components/layouts/dashboard-layout";
import React from "react";
import styled from "styled-components";
import { ReactComponent as Bg } from "images/svg/dashboardArtistBg.svg";
import { ReactComponent as MobileBg } from "images/svg/dashboardArtistMobileBg.svg";
import IndependentCard from "./components/independent-card";
import ProCard from "./components/pro-card";
import LabelCard from "./components/label-card";
import api from "services/axiosInstance";
import { useEffect, useState } from "react";

const DashboardUpgrade = () => {
  const [planStatus, setPlanStatus] = useState<
    "independent" | "pro" | "label" | "free"
  >("free");
  const [loading, setLoading] = useState(false);

  const GetPlanStatus = async () => {
    try {
      setLoading(true);
      const { data } = await api.get("users/plan-status");

      setPlanStatus(data.subscription);
    } catch (error) {
      setPlanStatus("free");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetPlanStatus();
  }, []);
  return (
    <DashboardLayout>
      <Main>
        <Cards>
          <IndependentCard
            isMonthly
            currentPlan={planStatus === "independent"}
            loading={loading}
          />
          <ProCard
            isMonthly={true}
            currentPlan={planStatus === "pro"}
            loading={loading}
          />
          <LabelCard
            isMonthly={true}
            currentPlan={planStatus === "label"}
            loading={loading}
          />
        </Cards>
        <BgImage>
          <Bg />
        </BgImage>
        <MobileBgImage>
          <MobileBg />
        </MobileBgImage>
      </Main>
    </DashboardLayout>
  );
};

export default DashboardUpgrade;

const Main = styled.div`
  position: relative;
`;
const Cards = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1.6rem;
  padding: 5rem 6rem;
  position: relative;
  z-index: 2;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 1fr;
    padding: 2.4rem;
  }
`;
const BgImage = styled.div`
  width: 110%;
  position: absolute;
  top: -5rem;
  left: -5%;
  z-index: 0;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;
const MobileBgImage = styled.div`
  position: absolute;
  width: 110%;
  top: -5rem;
  left: -5%;
  display: none;
  z-index: 0;
  @media only screen and (max-width: 769px) {
    display: flex;
  }
`;
